/* AUTO-GENERATED. No editar manualmente. */
export const APP_RUNTIME_LAYOUTS = Object.freeze({
  "IS_MODE_CELEBRATION_DATE": false,
  "IS_LOGO_TEST_CELEBRATION_DATE": false,
  "IS_LOGO_APP_DB_DYNAMIC": false
});
export const APP_RUNTIME_CELEBRATIONS = Object.freeze([
  {
    "id": "NEW_YEAR",
    "name": "Año Nuevo",
    "shortName": "Año Nuevo",
    "type": "GENERAL",
    "tags": [
      "new-year",
      "summer"
    ],
    "month": 1,
    "day": 1
  },
  {
    "id": "VALENTINES_DAY",
    "name": "Día de San Valentín",
    "shortName": "San Valentín",
    "type": "GENERAL",
    "tags": [
      "valentine",
      "love"
    ],
    "month": 2,
    "day": 14
  },
  {
    "id": "MEMORY_DAY_AR",
    "name": "Día Nacional de la Memoria por la Verdad y la Justicia",
    "shortName": "Día de la Memoria",
    "type": "ARGENTINA",
    "tags": [
      "argentina",
      "memory"
    ],
    "month": 3,
    "day": 24
  },
  {
    "id": "MALVINAS_DAY_AR",
    "name": "Día del Veterano y de los Caídos en la Guerra de Malvinas",
    "shortName": "Día de Malvinas",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "malvinas",
      "patriotic"
    ],
    "month": 4,
    "day": 2
  },
  {
    "id": "LABOR_DAY",
    "name": "Día Internacional del Trabajador",
    "shortName": "Día del Trabajador",
    "type": "GENERAL",
    "tags": [
      "labor",
      "worker"
    ],
    "month": 5,
    "day": 1
  },
  {
    "id": "MAY_REVOLUTION_AR",
    "name": "Día de la Revolución de Mayo",
    "shortName": "25 de Mayo",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "may-revolution"
    ],
    "month": 5,
    "day": 25
  },
  {
    "id": "GUEMES_DAY_AR",
    "name": "Paso a la Inmortalidad del General Martín Miguel de Güemes",
    "shortName": "Día de Güemes",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "guemes"
    ],
    "month": 6,
    "day": 17
  },
  {
    "id": "FLAG_DAY_AR",
    "name": "Paso a la Inmortalidad del General Manuel Belgrano",
    "shortName": "Día de la Bandera",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "flag",
      "belgrano"
    ],
    "month": 6,
    "day": 20
  },
  {
    "id": "INDEPENDENCE_DAY_AR",
    "name": "Día de la Independencia Argentina",
    "shortName": "9 de Julio",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "independence"
    ],
    "month": 7,
    "day": 9
  },
  {
    "id": "SAN_MARTIN_DAY_AR",
    "name": "Paso a la Inmortalidad del General José de San Martín",
    "shortName": "Día de San Martín",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "san-martin"
    ],
    "month": 8,
    "day": 17
  },
  {
    "id": "CULTURAL_DIVERSITY_DAY_AR",
    "name": "Día del Respeto a la Diversidad Cultural",
    "shortName": "Diversidad Cultural",
    "type": "ARGENTINA",
    "tags": [
      "argentina",
      "culture",
      "diversity"
    ],
    "month": 10,
    "day": 12
  },
  {
    "id": "HALLOWEEN",
    "name": "Halloween",
    "shortName": "Halloween",
    "type": "SEASONAL",
    "tags": [
      "halloween"
    ],
    "month": 10,
    "day": 31
  },
  {
    "id": "SOVEREIGNTY_DAY_AR",
    "name": "Día de la Soberanía Nacional",
    "shortName": "Soberanía Nacional",
    "type": "PATRIOTIC",
    "tags": [
      "argentina",
      "patriotic",
      "sovereignty"
    ],
    "month": 11,
    "day": 20
  },
  {
    "id": "IMMACULATE_CONCEPTION",
    "name": "Día de la Inmaculada Concepción de María",
    "shortName": "Inmaculada Concepción",
    "type": "RELIGIOUS",
    "tags": [
      "religious",
      "christian"
    ],
    "month": 12,
    "day": 8
  },
  {
    "id": "CHRISTMAS_EVE",
    "name": "Nochebuena",
    "shortName": "Nochebuena",
    "type": "SEASONAL",
    "tags": [
      "christmas",
      "christmas-eve"
    ],
    "month": 12,
    "day": 24
  },
  {
    "id": "CHRISTMAS",
    "name": "Navidad",
    "shortName": "Navidad",
    "type": "SEASONAL",
    "tags": [
      "christmas"
    ],
    "month": 12,
    "day": 25
  },
  {
    "id": "NEW_YEARS_EVE",
    "name": "Fin de Año",
    "shortName": "Fin de Año",
    "type": "SEASONAL",
    "tags": [
      "new-year",
      "new-years-eve"
    ],
    "month": 12,
    "day": 31
  },
  {
    "id": "CARNIVAL_MONDAY_AR",
    "name": "Lunes de Carnaval",
    "shortName": "Carnaval",
    "type": "ARGENTINA",
    "tags": [
      "argentina",
      "carnival"
    ],
    "date": "2026-02-16T15:00:00.000Z"
  },
  {
    "id": "CARNIVAL_TUESDAY_AR",
    "name": "Martes de Carnaval",
    "shortName": "Carnaval",
    "type": "ARGENTINA",
    "tags": [
      "argentina",
      "carnival"
    ],
    "date": "2026-02-17T15:00:00.000Z"
  },
  {
    "id": "HOLY_THURSDAY",
    "name": "Jueves Santo",
    "shortName": "Jueves Santo",
    "type": "RELIGIOUS",
    "tags": [
      "religious",
      "christian",
      "easter"
    ],
    "date": "2026-04-02T15:00:00.000Z"
  },
  {
    "id": "GOOD_FRIDAY",
    "name": "Viernes Santo",
    "shortName": "Viernes Santo",
    "type": "RELIGIOUS",
    "tags": [
      "religious",
      "christian",
      "easter"
    ],
    "date": "2026-04-03T15:00:00.000Z"
  },
  {
    "id": "EASTER_SUNDAY",
    "name": "Domingo de Pascua",
    "shortName": "Pascua",
    "type": "RELIGIOUS",
    "tags": [
      "religious",
      "christian",
      "easter"
    ],
    "date": "2026-04-05T15:00:00.000Z"
  }
]);
